import { put, takeLatest } from 'redux-saga/effects';
import { DocumentsAPI } from 'api/document/document-core';
import { getDocuments } from '../../actions/documents';
import { setDocuments } from '../../slice';
function* getDocumentsManager(action) {
    const { payload } = action;
    try {
        const response = yield DocumentsAPI.getDocumentsList(payload.projectId);
        yield put(setDocuments(response));
    } catch (unused) {
    // TODO
    }
}
export const watchGetDocuments = function*() {
    yield takeLatest(getDocuments.type, getDocumentsManager);
};
